export default [
  {
    path: '/delivery-notes',
    name: 'delivery-note-list',
    props: true,
    component: () => import('@/views/deliveryNotes/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Liste des bons de livraison',
      breadcrumb: [
        {
          text: 'Bons de livraison',
          to: { name: 'delivery-note-list' },
        },
        {
          text: 'Liste des bons de livraison',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier'],
    },
  },
  {
    path: '/delivery-notes/show/:id',
    name: 'delivery-note-show',
    props: true,
    component: () => import('@/views/deliveryNotes/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détails du bon de livraison',
      breadcrumb: [
        {
          text: 'Bons de livraison',
          to: { name: 'delivery-note-list' },
        },
        {
          text: 'Détails du bon de livraison',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier'],
    },
  },
  {
    path: '/delivery-notes/print-all/:orderIds',
    name: 'print-all',
    props: true,
    component: () => import('@/views/deliveryNotes/PrintAll.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Impression groupée des bons de livraison',
      breadcrumb: [
        {
          text: 'Bons de livraison',
          to: { name: 'delivery-note-list' },
        },
        {
          text: 'Impression groupée des bons de livraison',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier'],
    },
  },
]
